import { render } from "./Terrain.vue?vue&type=template&id=6d6b808c&scoped=true"
import script from "./Terrain.vue?vue&type=script&lang=js"
export * from "./Terrain.vue?vue&type=script&lang=js"

import "./Terrain.vue?vue&type=style&index=0&id=6d6b808c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-6d6b808c"

export default script